import React, { useState, useEffect } from "react";
import Header from "../../../Components/Header";
import Seo from "../../../Components/SeoComponent/Seo";
import { showSuccessToast, showErrorToast } from "../../../utils/toastUtils";
import { fetchProfile} from "../../../Services/ApiTestService/aadharTestService";
import { verifyPan } from "../../../Services/ApiTestService/panTestService";
import { InputWithLabel, Button } from "../../../Components/Tags/Tags";
import Loader from "../../../Loader";
import { Data2 } from "../Data";
import { Link } from "react-router-dom";
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { useService } from "../../../context/ServiceContext";  

const TestPan = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [panData,setPanData] = useState({});
  const [errors, setErrors] = useState({});
  const [profileData, setProfileData] = useState({});
  const [panNumber, setPanNumber] = useState('');
const { serviceName } = useService();

  // Fetch Profile Data on Mount
  useEffect(() => {
    async function fetchProfileData() {
      try {
        setIsLoading(true);
        const response = await fetchProfile(); 
        setProfileData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching profile data", error);
        showErrorToast("Failed to fetch profile data.");
        setIsLoading(false);
      }
    }
    fetchProfileData();
  }, []);


  const validatePan = () => {
    const errors = {};
    if (!panNumber || panNumber.length !== 10) {
      errors.panNumber = "Please enter a valid Pan number.";
      showErrorToast(errors.panNumber = "Please enter a valid 10-digit Pan number.")
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };





  const handleSubmit = async () => {
    if (!validatePan()) return;
  
    setIsLoading(true); // Start loader
    try {
      const response = await verifyPan({
        api_id: profileData?.user_id,
        api_key: profileData?.api_key,
        token_id: profileData?.token_id,
        pan_number: panNumber,
      });
  
      const statusCode = response?.status?.code || response?.status;
      const message = response?.message || response?.data?.message || response?.error?.message || "Something went wrong";
  
      if (statusCode === 200) {
        const panInfo = response?.data?.data;
        if (panInfo) {
          setPanData(panInfo);
          showSuccessToast(message || "PAN verified successfully");
        } else {
          showErrorToast("PAN data is missing in the response.");
        }
        setPanNumber(''); // Clear input
      } else {
        showErrorToast(`${message} (code: ${statusCode})`);
      }
  
    } catch (error) {
      showErrorToast("Failed to verify PAN. Please try again.");
    } finally {
      setIsLoading(false); // Always stop loader
    }
  };
  


  

  return (
    <>
    <Seo />
    {isLoading && <Loader />}
    <Header heading={serviceName} />

<div className="grid grid-cols-2 md:grid-cols-6 gap-3 justify-center md:ml-72 ml-0">

 
<div className="col-span-2 md:col-span-6 flex justify-end">
  <Link
    to="/TestMaster"
    className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
  >
    <span>Go Back</span>
    <IoArrowBackCircleOutline size={24} />
  </Link>
</div>


  <InputWithLabel
    type="text"
    label="Pan No"
    placeholder="Enter Pan No"
    maxLength={10}
    className="p-1 rounded shadow-lg shadow-blue-500/50 border border-blue-600 uppercase"
    name="pan"
    id="pan"
    required={true}
    value={panNumber}
    onChange={(e) => setPanNumber(e.target.value)}  
    error={errors.panNumber}
  />

  {/* Verify button for Pan No */}
  <div>
    <Button
      type="button"
      className="text-center text-white bg-blue-900 shadow-lg bg-gradient-to-r from-blue-400 via-blue-1200 to-blue-900 font-semibold rounded-md px-2 py-1 mt-5 text-md hover:from-blue-900 hover:to-blue-400 border-4 ms-2"
      id="verifyPan"
      name="verifyPan"
      text="Verify"
      onClick={handleSubmit}
    />
  </div>
</div>


<div class="max-w-2xl mx-auto p-2 bg-white rounded-2xl shadow-lg mt-2">
  <h2 class="text-xl font-bold text-center text-gray-800 mb-2">PAN Verification Steps</h2>

  <ol class="list-decimal list-inside text-gray-700 space-y-1">
    <li>Enter your 10-character PAN number carefully (e.g., ABCDE1234F).</li>
    <li>Click on "Verify PAN" to fetch your PAN card details directly.</li>
  </ol>

  <div class="mt-3">
    <h3 class="text-xl font-semibold text-gray-800 mb-2">Important Notes:</h3>
    <ul class="list-disc list-inside text-gray-600 space-y-1">
      <li>Ensure that you enter the correct PAN number without any spaces.</li>
      <li>PAN number is case-sensitive (use capital letters as printed on PAN card).</li>
      <li>Verification will fail if the PAN is invalid or not found.</li>
      <li>Keep your PAN card handy for cross-checking if needed.</li>
      <li>Your PAN number is confidential — do not share it unnecessarily.</li>
    </ul>
  </div>
</div>





{panData && Object.keys(panData).length > 0 && (
  <>
    <div className="flex justify-center">
      <h2 className="font-bold text-2xl mt-4">Pan Details</h2>
    </div>
    <div className="border border-gray-300 rounded-lg p-4 mt-1 flex justify-center shadow-inner shadow-blue-600">
      <div className="grid grid-cols-2 md:grid-cols-4 text-lg gap-3">
        <div className="px-2">
          <span className="font-bold">Name:</span> {panData?.full_name || "N/A"}
        </div>
        <div className="px-2">
          <span className="font-bold">Pan Number:</span> {panData?.pan_number || "N/A"}
        </div>
        <div className="px-2">
          <span className="font-bold">Category:</span> {panData?.category || "N/A"}
        </div>
        {/* Add more fields if needed */}
      </div>
    </div>
  </>
)}

{panData && Object.keys(panData).length > 0 && (
  <div className="border border-gray-300 rounded-lg p-1 mt-2 shadow-inner shadow-blue-800">
    <h2 className="text-2xl font-bold mb-2 text-center">API Response</h2>
    <pre className="bg-slate-100 p-1 rounded-md overflow-auto text-green-600">
      {JSON.stringify(panData, null, 2)}
    </pre>
  </div>
)}
    </> 

  )
}

export default TestPan
